/**
 * Recursively trims leading/trailing whitespace from all string values in an
 * object or array. Non-string values (numbers, booleans, Files, Dates, null,
 * undefined, etc.) are returned as-is. Returns a new object/array; the input is
 * not mutated.
 *
 * Intended for use at the top of Formik onSubmit handlers so saved entries
 * never include accidental leading/trailing spaces.
 */
const trimFormValues = (values) => {
  if (values === null || values === undefined) return values;
  if (typeof values === 'string') return values.trim();
  if (Array.isArray(values)) return values.map((v) => trimFormValues(v));
  if (typeof values === 'object') {
    // Preserve special objects (Date, File, Blob, FormData, etc.) instead of
    // walking their internals.
    if (
      values instanceof Date ||
      (typeof File !== 'undefined' && values instanceof File) ||
      (typeof Blob !== 'undefined' && values instanceof Blob) ||
      (typeof FormData !== 'undefined' && values instanceof FormData)
    ) {
      return values;
    }
    const result = {};
    for (const key in values) {
      if (Object.hasOwn(values, key)) {
        result[key] = trimFormValues(values[key]);
      }
    }
    return result;
  }
  return values;
};

export default trimFormValues;
